<template>
  <div>
    <el-upload
      class="multiple-img-uploader"
      :class="{ hidePlus: hidePlus }"
      :ref="uploadref"
      :list-type="listType"
      :show-file-list="showFileList"
      :file-list="imgFileList"
      :limit="limit"
      :action="uploadAction"
      :before-upload="beforeUpload"
      :on-preview="handlePreview"
      :on-exceed="handleExceed"
      :on-error="handleError"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-change="handleChange"
    >
      <template v-if="listType === 'picture-card'">
        <i class="el-icon-plus"></i>
      </template>
      <template v-if="listType === 'picture' || listType === 'text'">
        <slot name="uploadBtn">
          <el-button size="small" type="primary" class="fe-upload-btn">点击上传</el-button>
        </slot>
      </template>
      <div v-if="!hidetip" slot="tip" class="el-upload__tip font-size13 font-gray">
        请选择 <span class="font-red">jpg,png,jpeg</span>格式的照片上传,图片质量最大为
        <span class="font-red">{{ imgSize }}M</span>
      </div>
    </el-upload>
  </div>
</template>
<script>
import api from '@/api/base.new.api';
import { randomName } from '@fe/utils';
import { Loading } from 'element-ui';
export default {
  props: {
    limit: {
      type: Number,
      default: 1
    },
    viewerTitle: {
      type: String,
      default: ''
    },
    defaultFiles: {
      type: Array
    },
    hidetip: {
      type: Boolean,
      default: false
    },
    imgSize: {
      type: Number,
      default: 3
    },
    viewerType: {
      type: Number,
      default: 1
    },
    listType: {
      required: false,
      type: String,
      default: 'picture-card'
    },
    showFileList: {
      required: false,
      type: Boolean,
      default: true
    },
    loadingFlag: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      uploadAction: api.newUploadImg,
      imgFileList: [], // 默认文件
      hidePlus: false, // 达到最大上传数量 隐藏上传按钮
      uoloading: false,
      loading: null
    };
  },
  computed: {
    uploadref() {
      return 'upload' + randomName();
    }
  },
  watch: {
    defaultFiles: function (newValue, oldValue) {
      this.clearImgFileList();
      this.imgFileList = this.onFormatFiles();
      this.hidePlus = this.imgFileList.length >= this.limit;
    },
    uoloading(newValue, oldValue) {
      if (this.loadingFlag) {
        if (newValue) {
          //添加loading
          this.loading = Loading.service({
            fullscreen: true,
            background: 'rgba(255,255,255,0)'
          });
        } else {
          if (this.loading) this.loading.close();
        }
      }
    }
  },
  created() {
    this.imgFileList = this.onFormatFiles();
    this.hidePlus = this.imgFileList.length >= this.limit;
  },
  methods: {
    // 默认文件结构转换
    onFormatFiles() {
      const defaultFiles = this.defaultFiles || [];
      // 当页面并未提交  需要预览blob图片  但提交需要response里的服务端返回路径 defaultFiles必须是如下结构
      // {
      //   fileUrl:'/wyyt/xxx/123.jpg',
      //   blobUrl:'blob:http:/xxx/xxx/2324'
      // }
      return defaultFiles.map(el => {
        if (typeof el === 'string') {
          return { name: el, url: el };
        } else {
          return {
            name: el.fileUrl,
            url: el.blobUrl,
            response: {
              data: { fileUri: el.fileUrl }
            }
          };
        }
      });
    },
    // 图片预览
    handlePreview(file) {
      if (!file) return;
      if (this.viewerType == 1) {
        this.$store.dispatch('showViewer', { data: [{ url: file.url, title: this.viewerTitle || '上传的图片' }] });
      } else {
        this.$emit('preview');
      }
    },
    // 图片上传前钩子
    beforeUpload(file) {
      // 上传之前 验证文件格式
      const isImage = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      const isSize = file.size / 1024 / 1024 < this.imgSize;
      if (!isImage) this.$message.error('上传图片只能是 jpg,png,jpeg 格式!');
      if (!isSize) this.$message.error(`上传图片大小不能超过 ${this.imgSize}MB!`);
      if (isImage && isSize) {
        this.uoloading = true;
      }
      return isImage && isSize;
    },
    // 上传超过限制
    handleExceed(files, fileList) {
      this.uoloading = false;
      this.$message.error(`最多只能上传${this.limit}张图片凭证`);
    },
    // 图片移除成功钩子
    handleRemove(file, fileList) {
      this.hidePlus = fileList.length >= this.limit;
      this.uoloading = false;
      let removeFile = null;
      if (file.response) {
        removeFile = file.response.data.fileUri;
      } else {
        removeFile = file.url;
      }
      this.$emit('remove', removeFile, this.getUploadFiles());
    },
    // 图片上传出错钩子
    handleError(err, file, fileList) {
      this.uoloading = false;
      this.$message.error('发生错误，上传失败');
    },
    // 图片上传成功钩子
    handleSuccess(response, file, fileList) {
      this.uoloading = false;
      if (response.code === 0) {
        this.$emit('success', response.data.fileUri, this.getUploadFiles());
      } else {
        this.$message.error(response.message || '上传失败');
      }
    },
    handleChange(file, fileList) {
      this.hidePlus = fileList.length >= this.limit;
      // 目前需要页面自己提交时校验文件  message弹出消息
      // 如果做到form表单校验  页面自己处理保存文件信息 相对麻烦暂时不做
      // this.$emit('change', file.response.data.fileUri, this.getUploadFiles());
    },
    // 获取upload表单中的上传文件信息
    getUploadFiles(isloc = false) {
      if (this.uoloading) {
        this.$message.error('请等待图片上传完成');
        throw new Error('请等待图片上传完成');
      }
      const fileArray = this.$refs[this.uploadref].uploadFiles || [];
      return fileArray.map(item => {
        // 新上传的图片 取response里服务器返回的路径
        if (item.response) {
          if (isloc) {
            return item.url; // 取本地blod路径
          } else {
            return item.response.data.fileUri; // 取服务器返回的路径
          }
        } else {
          // 已上传 未更改的图片 取原路径
          return item.url;
        }
      });
    },
    // 清除上传图片缓存
    clearImgFileList() {
      this.$refs[this.uploadref].clearFiles();
      this.imgFileList = [];
    }
  }
};
</script>
<style lang="postcss">
.multiple-img-uploader .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 106px;
  border-radius: 2px;
}
.multiple-img-uploader {
  .el-upload-list--picture-card {
    .el-progress {
      width: 80px !important;
    }
    .el-progress-circle {
      width: 80px !important;
    }
    .el-progress {
      top: 75%;
    }
    .el-progress .el-progress__text {
      top: 30%;
    }
    .el-upload-list__item {
      width: 100px;
      height: 100px;
      border-radius: 2px;
      transition: none !important;
    }
  }
  .el-upload__tip {
    padding-bottom: 5px;
  }
}
.multiple-img-uploader.hidePlus {
  .el-upload--picture-card {
    display: none;
  }
}
</style>
